class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.loadRecommendations();
  }

  loadRecommendations() {
    fetch(this.dataset.url)
      .then(response => {
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length > 0) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(error => {
        /* eslint-disable no-console */
        console.error(error);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
